<template>
  <div
    v-if="active"
    class="console-polling-status"
    :class="[
      `console-polling-status--${tone}`,
      { 'console-polling-status--busy': busy },
    ]"
    role="status"
    aria-live="polite"
  >
    <span class="console-polling-status__dot" />
    <span class="console-polling-status__text">{{ busy ? busyLabel : idleLabel }}</span>
  </div>
</template>

<script setup>
defineProps({
  active: {
    type: Boolean,
    default: false,
  },
  busy: {
    type: Boolean,
    default: false,
  },
  idleLabel: {
    type: String,
    required: true,
  },
  busyLabel: {
    type: String,
    required: true,
  },
  tone: {
    type: String,
    default: 'active',
  },
})
</script>

<style scoped>
.console-polling-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 6px 10px;
  border: 1px solid var(--shell-border);
  border-radius: 999px;
  background: var(--shell-surface-strong);
  color: var(--shell-text-muted);
  font-family: var(--shell-mono-font);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.console-polling-status__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--status-active);
  animation: consolePollingPulse 1.8s ease-in-out infinite;
}

.console-polling-status--active {
  border-color: var(--status-active-border);
  background: var(--status-active-bg);
}

.console-polling-status--active .console-polling-status__dot {
  background: var(--status-active);
}

.console-polling-status--pending {
  border-color: var(--status-pending-border);
  background: var(--status-pending-bg);
}

.console-polling-status--pending .console-polling-status__dot {
  background: #6b7280;
}

.console-polling-status--busy {
  color: var(--shell-text);
}

.console-polling-status--busy .console-polling-status__dot {
  animation-duration: 0.9s;
}

@keyframes consolePollingPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.55;
    transform: scale(0.82);
  }
}
</style>
